<template>
    <CoreCatalogActionBar>
        <div class="o-row--full">
            <div class="o-extra-small--12">
                <div class="c-catalog-action-bar__content">
                    <div class="c-catalog-action-bar__left">
                        <CatalogSort
                            :sortOptions="sortOptions"
                            class="c-catalog-action-bar__sort"
                        />
                    </div>
                    <div class="c-catalog-action-bar__middle o-flex-horizontal-center">
                        <CatalogSizeLauncher
                            :catalogContext="catalogContext"
                            class="c-catalog-action-bar__size"
                        />
                        <FilterGroupMenuLauncher
                            :selectedFilterOptionsText="selectedFilterOptionsText"
                            :selectedFilterOptionsCount="selectedFilterOptionsCount"
                            :catalogContext="catalogContext"
                            :catalogFilterGroupModal="catalogFilterGroupModal"
                            :productTourAttributes="productTourAttributes"
                            @reset-filters="resetFilters"
                        />
                    </div>
                    <CatalogAvailabilityFilter
                        v-if="!isPrePurchase"
                        :catalogContext="catalogContext"
                        class="c-catalog-action-bar__right"
                    />
                    <div v-else class="c-catalog-action-bar__right"></div>
                </div>
            </div>
        </div>
    </CoreCatalogActionBar>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { useState } from '~coreModules/core/js/composables/vuexHelpers';
import { useMediaQueries } from '~coreModules/core/js/composables/useMediaQueries';

import { getClearAllFiltersLinkObject } from '~modules/catalog/js/catalog-utils';

import { MODALS } from '~modules/modals/js/modal-constants';
import { CATALOG_TOUR_LIGHTBOXES } from '~modules/product-tour/js/product-tour-constants';

import CatalogSort from '~coreModules/catalog/components/CatalogSort.vue';
import CoreCatalogActionBar from '~coreModules/catalog/components/CoreCatalogActionBar.vue';
import FilterGroupMenuLauncher from '~coreModules/catalog/components/FilterGroupMenuLauncher.vue';

import CatalogAvailabilityFilter from '~modules/catalog/components/CatalogAvailabilityFilter.vue';
import CatalogSizeLauncher from '~modules/catalog/components/CatalogSizeLauncher.vue';

const props = defineProps({
    catalogContext: {
        type: String,
        required: true,
    },
    selectedFilterOptionsText: {
        type: String,
        default: '',
    },
    selectedFilterOptionsCount: {
        type: Number,
        default: 0,
    },
    sortOptions: {
        type: Array,
        required: true,
    },
});

const route = useRoute();
const router = useRouter();
const mediaQueries = useMediaQueries();

// eslint-disable-next-line vue/no-setup-props-reactivity-loss
const { isPrePurchase } = useState(props.catalogContext, {
    isPrePurchase: 'isPrePurchase',
});

const catalogFilterGroupModal = MODALS.catalogFilterGroups;

const productTourAttributes = computed(() => {
    if (process.env.VUE_ENV !== 'client') {
        return undefined;
    }

    const {
        sizesSmall,
        sizesMedium,
        availabilitySmall,
    } = CATALOG_TOUR_LIGHTBOXES;

    let dataAttribute;

    if (mediaQueries.isExtraSmall) {
        dataAttribute = `${sizesSmall.selector},${availabilitySmall.selector}`;
    } else if (mediaQueries.isSmall || mediaQueries.isMedium) {
        dataAttribute = `${sizesMedium.selector}`;
    } else {
        dataAttribute = undefined;
    }

    return dataAttribute;
});

function resetFilters() {
    const { query } = route;
    router.replace(getClearAllFiltersLinkObject(query, {
        maintainSizePreferences: true,
        maintainAvailibilityFilter: true,
    }));
}

</script>

<style lang="scss">
    .c-catalog-action-bar {

        &__content {
            display: flex;
            justify-content: space-between;
        }

        &__left {
            justify-content: flex-start;
            display: flex;

            @include breakpoint(medium) {
                flex: 1;
            }
        }

        &__middle {
            flex: 1;
            display: flex;
        }

        &__right {
            display: none;
            justify-content: flex-end;
            flex: 1;

            @include breakpoint(medium) {
                display: flex;
            }
        }

        &__sort {
            display: none;
            margin-top: -$nu-spacer-2;

            @include breakpoint(medium) {
                display: flex;
            }
        }

        &__size {
            display: none;
            margin-right: $nu-spacer-1;

            @include breakpoint(large) {
                display: flex;
            }
        }
    }
</style>
